<template>
  <div>
    <el-cascader v-model="selects"
                 @change="hanleChange"
                 style="width: 100%;"
                 placeholder="请选择..."
                 :options="datas"
                 :props='cascaderProps'
                 clearable
                 filterable />
  </div>
</template>

<script>
export default {
  name: 'TicCascader',
  props: {
    datas: {
      default: () => [],
      type: Array,
    },
    cascaderIds: {
      default: () => [],
      type: Array,
    },
    cascaderProps: {
      default: () => [],
      type: Object,
    },
  },
  data() {
    return {
      options: [],
      selects: [],
    }
  },
  mounted() {},
  methods: {
    hanleChange(val) {
      console.log(val)
      this.$emit('emit:cascader', val)
    },
  },
  watch: {
    cascaderIds(nVal) {
      debugger
      if (nVal.cascaderIds) {
        this.selects = nVal.cascaderIds
      } else {
        this.selects = []
      }
    },
  },
}
</script>